var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-heading"},[_vm._m(0),_vm._t("title"),_vm._m(1)],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('i',{staticStyle:{"position":"relative","top":"5px","margin-right":"5px"}},[_c('img',{attrs:{"src":require("@/assets/titleBlock/heading1.png"),"alt":""}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('i',{staticStyle:{"position":"relative","top":"5px","margin-left":"5px"}},[_c('img',{attrs:{"src":require("@/assets/titleBlock/heading2.png"),"alt":""}})])
}]

export { render, staticRenderFns }